import { useDebouncedValue } from "@mantine/hooks";
import { useEffect, useState } from "react";

import { ShippingCompanySearch, useLazySearchShippingCompaniesQuery } from "@/store";

export type UseSearchShippingCompanyParams = {
  search?: string;
  getValue?: (company: ShippingCompanySearch) => string;
  getLabel?: (company: ShippingCompanySearch) => string;
};
export function useSearchShippingCompany({ search = "", getValue, getLabel }: UseSearchShippingCompanyParams = {}) {
  const [searchShippingCompany, setSearchShippingCompany] = useState(search);
  const [debouncedSearchShippingCompany] = useDebouncedValue(searchShippingCompany, 300);
  const [searchShippingCompanies, { data: companies, ...state }] = useLazySearchShippingCompaniesQuery({
    selectFromResult: (state) => ({
      ...state,
      data: {
        options:
          state.data?.map((company) => ({
            value: getValue?.(company) || String(company.id),
            label: getLabel?.(company) || company.name
          })) || [],
        result: state.data || []
      }
    })
  });

  useEffect(() => {
    if (debouncedSearchShippingCompany.trim().length) {
      searchShippingCompanies({ query: debouncedSearchShippingCompany });
    }
  }, [debouncedSearchShippingCompany, search]);

  return {
    data: companies,
    actions: {
      setSearchShippingCompany
    },
    state: {
      searchShippingCompany,
      debouncedSearchShippingCompany,
      ...state
    }
  };
}
